import { debounce } from "lodash";
import React from "react";
import { autocomplete } from "../../api/map";
export type GoogleAddressFields = Array<
	'unit_number' | 'street_number' | 'street_name' | 'street_type' | 'city' | 'state' | 'country' | 'postcode'
>;
const componentForm = {
	street_number: 'short_name',
	route: 'long_name',
	locality: 'long_name',
	administrative_area_level_1: 'short_name',
	country: 'short_name',
	postal_code: 'short_name',
	subpremise: 'long_name',
};
const mapGoogleToMaster = {
	street_number: 'street_number',
	route: 'street_name',
	locality: 'city',
	administrative_area_level_1: 'state',
	country: 'country',
	postal_code: 'postcode',
	subpremise: 'unit_number',
};
export const parsePlaceComponents = (
	components: Array<{
		long_name: string;
		short_name: string;
		types: Array<string>;
	}>,
	addressFields?: GoogleAddressFields
) => {
	const result: { [key: string]: string } = {};
	components.forEach((component) => {
		const componentType = component.types[0];
		if (componentForm[componentType]) {
			const val = component[componentForm[componentType]];
			// Hack to split out the street type as API doesn't support it - not 100% accurate
			if (componentType === 'route') {
				const street = val.split(' ');
				result.street_type = street.pop();
				result[mapGoogleToMaster[componentType]] = street.join(' ');
			} else if (!addressFields || addressFields.includes(mapGoogleToMaster[componentType]))
				result[mapGoogleToMaster[componentType]] = val;
		}
	});

	return result;
};

const useAddressQuery = (countryCode:string,onChangeCallback?:()=>void) => {
	const [query, setQuery] = React.useState<string>('');
    const [predictions, setPredictions] = React.useState<Array<{ description: string; place_id: string }>>([]);
    const handleSearch = React.useCallback(
		debounce((query: string) => {
			if(query.length < 3) return setPredictions([])
			if(!query.match(/[a-zA-Z]/g)) return setPredictions([])
			autocomplete(query,countryCode).then(({data}) => {
				if(Array.isArray(data.predictions)){
					setPredictions(data.predictions);
				}
			});
		}, 500),
		[countryCode]
	);
	const clearPredictions = React.useCallback(() => {
		setPredictions([]);
	},[])
    const onChangeQuery = React.useCallback(
		(query: string) => {
			setQuery(query);
			handleSearch(query);
			onChangeCallback?.()
		},
		[handleSearch, onChangeCallback]
	);
    return {
        query,
        predictions,
        setQuery,
        onChangeQuery,
		clearPredictions
    }
}
export default useAddressQuery